import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../app.json";
import * as qs from "query-string";
import { Redirect } from "react-router-dom";
import { useQuery, useMutation } from "@apollo/react-hooks";
import { UPDATE_ALLERGY } from "../../queries/patient.query";
import { LIST } from "../../queries/allergy.query";
import LoadingSpinner from "../../partials/loading";
import AlertMessage from "../../partials/alertMessage";
import auth from "../../providers/Auth.Provider";
import Select from "react-dropdown-select";
import { toast } from "react-toastify";

function Allergy({ location, history, match }) {
  const [items, setItem] = useState([]);
  const [list, setList] = useState([]);

  // Authentication
  const { GetToken, GetAuthenticatedStaff } = auth.authProvider;
  // Get patient reference
  const { ref } = qs.parse(location.search, {
    ignoreQueryPrefix: true
  });
  const { id } = match.params;
  const { site } = GetToken() && GetAuthenticatedStaff();

  const _ProfileLink = `/home/patient/profile/${ref || id}/summary`;
  // query statement
  const { loading } = useQuery(LIST, {
    variables: { site: site && site.id },
    onCompleted: data => {
      setList(data.GetAllergies.docs.map(i => ({ id: i.id, name: i.name })));
    }
  });
  // Post staff assignment
  const [UpdateFunc, { loading: uLoading, error: uError }] = useMutation(UPDATE_ALLERGY, {
    onCompleted: data => {
      if (data.UpdatePatientAllergies) {
        toast.success(data.UpdatePatientAllergies.message);
        history.push(_ProfileLink);
      }
    }
  });

  const title = "Update Patient Allergy";

  if (!ref && !id)
    return (
      <Redirect
        to={{
          pathname: _ProfileLink
        }}
      />
    );

  return (
    <>
      <Helmet>
        <title>
          {title} | {appName}
        </title>
      </Helmet>
      <div className="row justify-content-center">
        <div className="col-md-12">
          <div className="card">
            <div className="card-head">
              <header>
                <button
                  onClick={() => {
                    history.push(_ProfileLink);
                  }}
                  title="Back"
                  className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
                >
                  <i className="material-icons text-primary">keyboard_backspace</i>
                </button>
                {title}
              </header>
            </div>
            <div className="card-body">
              <form
                onSubmit={evt => {
                  evt.preventDefault();
                }}
              >
                <div className="form-group">
                  {loading && <LoadingSpinner loading={loading} bar={true} />}
                  <Select
                    options={list}
                    multi={true}
                    valueField="id"
                    labelField="name"
                    onChange={values => setItem(values)}
                    searchable={true}
                    color="#0066f5"
                    searchBy="name"
                    addPlaceholder="+ Select Allergy"
                    clearable={true}
                    separator={true}
                  />
                </div>
              </form>
              {items.length > 0 && (
                <>
                  <ol className="margin-top-20 fade-in">
                    {items.map((item, idx) => (
                      <li
                        onClick={() => {
                          const idxOf = items.indexOf(item);
                          const newList = items;
                          newList.splice(idxOf, 1);
                          setItem([...newList]);
                        }}
                        className="fade-in"
                        key={idx}
                      >
                        {item.name}
                      </li>
                    ))}
                  </ol>
                  <p>
                    <small>Note: Click on any of the item to remove.</small>
                  </p>
                  <LoadingSpinner loading={uLoading} bar={true} />
                  <AlertMessage message={uError && uError.message} failed={true} />

                  <div className="fade-in">
                    <button
                      type="button"
                      onClick={() => {
                        setItem([]);
                      }}
                      className="mdl-button  mdl-js-ripple-effect text-pink btn-circle"
                    >
                      <i className="material-icons">clear_all</i> Clear List
                    </button>
                    <button
                      onClick={async () => {
                        await UpdateFunc({
                          variables: {
                            patient: ref,
                            items: items.map(i => i.id)
                          }
                        });
                      }}
                      type="button"
                      className="mdl-button  mdl-button--raised mdl-js-ripple-effect btn-success pull-right btn-circle"
                    >
                      Submit Allergy <i className="material-icons">arrow_right_alt</i>
                    </button>
                  </div>
                </>
              )}
              {!items.length && <h4 className="text-center text-pink fade-in">No allergy is added yet!</h4>}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Allergy;
